import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor() { }

  // 3 years data: One data per quarter + last date

  portfolioCardCharts() {
    return {
      accrued: [{
      name: 'Portfolio Accrued',
      data: [502, 635, 809, 947, 1402, 3634, 502, 635, 809, 947, 1402, 5268]
      }],
      volatility: [{
        name: 'Portfolio Volatility',
        data: [0.10, 0.15, 0.13, 0.17, 0.15, 0.13, 0.10, 0.15, 0.13, 0.17, 0.15, 0.13, 0.12]
      }],
      maxdd: [{
        name: 'Portfolio Max Drawdown',
        data: [-0.24, -0.27, -0.35, -0.42, -0.36, -0.26, -0.24, -0.27, -0.35, -0.42, -0.36, -0.26, -0.23]
      }],
      cf5var: [{
        name: 'Portfolio VaR',
        data: [1.57, 3.25, 5.36, 6.37, 5.34, 4.35, 1.57, 3.25, 5.36, 6.37, 5.34, 4.35, 7.7]
      }]
    };
  }

  benchmarkCardCharts() {
    return {
      accrued: [{
      name: 'Benchmark Accrued',
      data: [492, 543, 785, 958, 1302, 3232, 492, 543, 785, 958, 1302, 3000]
      }],
      volatility: [{
        name: 'Benchmark Volatility',
        data: [0.10, 0.15, 0.13, 0.17, 0.15, 0.13, 0.10, 0.15, 0.13, 0.17, 0.15, 0.13, 0.16]
      }],
      maxdd: [{
        name: 'Benchmark Max Drawdown',
        data: [-0.24, -0.27, -0.35, -0.42, -0.36, -0.26, -0.24, -0.27, -0.35, -0.42, -0.36, -0.26, -0.23]
      }],
      cf5var: [{
        name: 'Benchmark VaR',
        data: [1.57, 3.25, 5.36, 6.37, 5.34, 4.35, 1.57, 3.25, 5.36, 6.37, 5.34, 4.35, 8.6]
      }]
    };
  }

  zoneChart() {
    return [
      {name: 'USA', y: 45, color: 'rgb(95,178,98)'},
      {name: 'Eurozone', y: 25, color: 'rgb(255,195,46)'},
      {name: 'Japan', y: 20, color: 'rgb(161,68,180)'},
      {name: 'United Kingdom', y: 15, color: 'rgb(62,156,243)'}
    ];
  }

  currencyChart() {
    return [{
      name: 'USD',
      data: [0.15]
    }, {
      name: 'EURO',
      data: [0.40]
    }, {
      name: 'GBP',
      data: [0.25]
    }, {
      name: 'JPY',
      data: [0.20]
    }];
  }

  ratingChart() {
    return [{
      name: 'Original',
      data: [132, 105, 92, 73, 64, 12]
    }, {
      name: 'Investable',
      data: [125, 110, 86, 64, 81, 13]
    }, {
      name: 'Protected',
      data: [111, 90, 60, 62, 87, 14]
    }];
  }

  intensityChart() {
    return [[1.5, 2.6], [2.7, 4.8], [4.5, 1.6]];
  }

  portfolioTable() {
    return [
      {creationDate: '2020-05-03', name: 'Lyxor MSCI USA UCITS', weight: '12.5%', zone: 'United States'},
      {creationDate: '2019-09-07', name: 'iShares STOXX Europe 600 UCITS', weight: '3.8%', zone: 'Europe'},
      {creationDate: '2019-06-04', name: 'RBC Quant U.S. Equity', weight: '4.7%', zone: 'United States'},
      {creationDate: '2019-03-25', name: 'UK Large & Mid Cap Stocks', weight: '10.1%', zone: 'United Kingdom'},
      {creationDate: '2019-01-15', name: 'AMUNDI Japan TOPIX UCITS', weight: '9.4%', zone: 'Japan'},
      {creationDate: '2018-11-26', name: 'My Portfolio 6', weight: '7.3%', zone: 'United States'},
      {creationDate: '2018-07-01', name: 'My Portfolio 7', weight: '5.5%', zone: 'Europe'},
      {creationDate: '008', name: 'Oxygen', weight: '15.9994', zone: 'O'},
      {creationDate: '009', name: 'Fluorine', weight: '18.9984', zone: 'F'},
      {creationDate: '010', name: 'Neon', weight: '20.1797', zone: 'Ne'},
      {creationDate: '011', name: 'Sodium', weight: '22.9897', zone: 'Na'},
      {creationDate: '012', name: 'Magnesium', weight: '24.305', zone: 'Mg'},
      {creationDate: '013', name: 'Aluminum', weight: '26.9815', zone: 'Al'},
      {creationDate: '014', name: 'Silicon', weight: '28.0855', zone: 'Si'},
      {creationDate: '015', name: 'Phosphorus', weight: '30.9738', zone: 'P'},
      {creationDate: '016', name: 'Sulfur', weight: '32.065', zone: 'S'},
      {creationDate: '017', name: 'Chlorine', weight: '35.453', zone: 'Cl'},
      {creationDate: '018', name: 'Argon', weight: '39.948', zone: 'Ar'},
      {creationDate: '019', name: 'Potassium', weight: '39.0983', zone: 'K'},
      {creationDate: '020', name: 'Calcium', weight: '40.078', zone: 'Ca'},
    ]
  }

}
